module.exports = __webpack_public_path__ + "img/menu.092fe277.svg";